module.exports = __webpack_public_path__ + "img/div6.6f28668e.jpg";